<template>

    <v-dialog width="fit-content" v-model="dialog">

        <template v-slot:activator="{ on }">
            <v-card-text class="location-link" flat v-on="on" href="#">{{ thisRestaurant.address }}</v-card-text>
        </template>

        <v-card>
            <v-container>
                <v-layout row>
                    <v-flex xs12>
                        <v-card-title>
                            <span class="title--primary">{{ thisRestaurant.name }}</span>
                            <div class="dialog-closeBtn" @click="dialog = false"><v-icon left>mdi-close</v-icon></div>
                        </v-card-title>
                    </v-flex>
                </v-layout>
                <v-layout row>
                    <v-flex xs12>
                        <GmapMap
                            ref="mapRef"
                            :options="{
                                zoomControl: true,
                                mapTypeControl: false,
                                scaleControl: true,
                                streetViewControl: false,
                                rotateControl: false,
                                fullscreenControl: true,
                                disableDefaultUi: false
                            }"
                            :center="map_center"
                            :zoom="map_zoom"
                            map-type-id="terrain"
                            style="width: 800px; height: 420px"
                        >
                            <GmapMarker v-if="map_marker" :position="map_marker" />
                        </GmapMap>
                        <!-- <iframe :src="thisRestaurant.locationSrc"
                                width="800" height="260" frameborder="0" style="border:0;" allowfullscreen=""></iframe> -->
                       <!-- <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn>Удалить</v-btn>
                            <v-btn>Отмена</v-btn>
                        </v-card-actions>-->
                    </v-flex>
                </v-layout>
            </v-container>
        </v-card>
    </v-dialog>

</template>

<script>
import {mapGetters} from 'vuex'
import {gmapApi} from 'vue2-google-maps'
import * as _ from 'lodash'

const DEFAULT_MAP_CENTER = {lat:51.4, lng:0}; // default London

export default {
    name: "LocationAddressModal",
    props: ['thisRestaurantId'],
    data(){
        return{
            dialog: false,
            map_center: DEFAULT_MAP_CENTER, // default: London
            map_zoom: 12,
            map_marker: void 0,
            is_initialized: false,
        }
    },
    computed: {
        ...mapGetters([
            'options',
        ]),
        thisRestaurant () {
            const id = this.thisRestaurantId
            
            // check restaurant
            let user = JSON.parse(localStorage.getItem("user"));
            if(user.role == 'restaurant') {
                return _.find(user.restaurants, p => p.id == id);
            }

            // its admin
            return this.$store.getters.restaurantById(id)
        },
        google: gmapApi,
    },
    updated() {
        if (!this.$data.dialog) {
            this.$data.is_initialized = false;
            return; // exit dialog closed
        }

        if (this.$data.is_initialized) {
            return;
        }

        let me = this;
        me.$data.map_marker = void 0;

        if (!this.thisRestaurant.map_latitude || !this.thisRestaurant.map_longitude) {
            // setup map default center
            let option = _.find(me.options, p => p.okey == 'map_center_default');
            let map_options = JSON.parse(option.ovalue);

            me.map_center = {
                lat: map_options.lat,
                lng: map_options.lng
            };
            me.map_zoom = map_options.map_zoom;

            me.$data.is_initialized = true;
            return;
        }

        let timerId = setInterval(() => { // await while google load scripts
            if(!me.google) {
                return;
            }

            clearInterval(timerId);
            me.$data.is_initialized = true;

            me.$refs.mapRef.$mapPromise.then((map) => {
                me.$data.map_marker = new me.google.maps.LatLng(
                    me.thisRestaurant.map_latitude,
                    me.thisRestaurant.map_longitude
                );

                var bounds = new me.google.maps.LatLngBounds();
                bounds.extend(me.$data.map_marker);
                
                map.setCenter(bounds.getCenter()); //or use custom center
                map.setZoom(me.map_zoom);
            });
        }, 10);
    }
}
</script>

<style scoped>

</style>